import { useEffect, useState } from "react";

const getViewportWidth = () =>
  typeof window === "undefined" ? 1280 : window.innerWidth;

const sizeForViewport = (viewportWidth, laptop, desktop, wide) => {
  if (viewportWidth < 768) {
    return Math.max(viewportWidth - 24, 320);
  }
  if (viewportWidth < 1600) {
    return laptop;
  }
  if (viewportWidth < 1920) {
    return desktop;
  }
  return wide;
};

export const getFaqDrawerWidth = () => {
  const viewportWidth = getViewportWidth();
  if (viewportWidth < 768) {
    return viewportWidth;
  }
  return sizeForViewport(viewportWidth, 520, 680, 800);
};

export const getFaqModalWidth = () => {
  const viewportWidth = getViewportWidth();
  return sizeForViewport(viewportWidth, 560, 720, 840);
};

export const useFaqPanelSize = () => {
  const [size, setSize] = useState(() => ({
    drawerWidth: getFaqDrawerWidth(),
    modalWidth: getFaqModalWidth(),
  }));

  useEffect(() => {
    const updateSize = () => {
      setSize({
        drawerWidth: getFaqDrawerWidth(),
        modalWidth: getFaqModalWidth(),
      });
    };
    window.addEventListener("resize", updateSize);
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  return size;
};
